var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelledStatusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6018 13.8268C14.9661 14.1911 14.9661 14.7375 14.6018 15.1018C14.4196 15.2839 14.2375 15.375 13.9643 15.375C13.6911 15.375 13.5089 15.2839 13.3268 15.1018L8.5 10.275L3.67321 15.1018C3.49107 15.2839 3.30893 15.375 3.03571 15.375C2.7625 15.375 2.58036 15.2839 2.39821 15.1018C2.03393 14.7375 2.03393 14.1911 2.39821 13.8268L7.225 9L2.39821 4.17321C2.03393 3.80893 2.03393 3.2625 2.39821 2.89821C2.7625 2.53393 3.30893 2.53393 3.67321 2.89821L8.5 7.725L13.3268 2.89821C13.6911 2.53393 14.2375 2.53393 14.6018 2.89821C14.9661 3.2625 14.9661 3.80893 14.6018 4.17321L9.775 9L14.6018 13.8268Z",
    fill: "#D95945"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4663_54178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 11,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2457 12.7535C13.529 13.0368 13.529 13.4618 13.2457 13.7452C13.104 13.8868 12.9623 13.9577 12.7498 13.9577C12.5373 13.9577 12.3957 13.8868 12.254 13.7452L8.49984 9.99102L4.74567 13.7452C4.604 13.8868 4.46234 13.9577 4.24984 13.9577C4.03734 13.9577 3.89567 13.8868 3.754 13.7452C3.47067 13.4618 3.47067 13.0368 3.754 12.7535L7.50817 8.99935L3.754 5.24518C3.47067 4.96185 3.47067 4.53685 3.754 4.25352C4.03734 3.97018 4.46234 3.97018 4.74567 4.25352L8.49984 8.00768L12.254 4.25352C12.5373 3.97018 12.9623 3.97018 13.2457 4.25352C13.529 4.53685 13.529 4.96185 13.2457 5.24518L9.4915 8.99935L13.2457 12.7535Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4663_54178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H17V17.5H0V0.5Z",
    fill: "#D95945"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledStatusIcon);
export default __webpack_public_path__ + "static/media/CancelledStatusIcon.27912ff2114c0d393e7e632cc99c54b2.svg";
export { ForwardRef as ReactComponent };